import {AOperation} from "./AOperation";
import GPSCoordinates from "../GPSCoordinates";
import {EOperationType} from "../utils/EOperationType";
import {AEquipment} from "../equipments/AEquipment";
import {Icon} from "../Icon";
import MarkerIconService from "../../services/map/MarkerIconService";
import {CSS_CLASS_NAME_GRAY_MARKER, CSS_CLASS_NAME_ORANGE_MARKER} from "../../services/UtilsService";
import RemapService from "../../services/RemapService";

export class InstallationEquipment extends AOperation {

    private _equipment: AEquipment | undefined;

    constructor(id: string, idUser: string, date: Date, equipment?: AEquipment, geolocation?: GPSCoordinates, isSynchro?: boolean, commentary?: string) {
        const icon = new Icon(
            MarkerIconService.OPERATION_INSTALLATION_EQUIPMENT_ICON_PATH,
            MarkerIconService.generateIcon(MarkerIconService.OPERATION_INSTALLATION_EQUIPMENT_ICON_PATH, isSynchro ? CSS_CLASS_NAME_ORANGE_MARKER : CSS_CLASS_NAME_GRAY_MARKER)
        );
        super(id, idUser, EOperationType.InstallationEquipment, date, icon, geolocation, isSynchro, commentary);
        this._equipment = equipment;
    }

    get equipment(): AEquipment | undefined {
        return this._equipment;
    }

    set equipment(value: AEquipment | undefined) {
        this._equipment = value;
    }

    public static remapObjectToOperation(object: any): InstallationEquipment | null {
        let operation: InstallationEquipment | null = null;
        if(
            object._id &&
            object._idUser &&
            object._date &&
            object._geolocation &&
            object._equipment
        ) {
            const location = GPSCoordinates.remapObjectToGPSCoordinate(object._geolocation);
            const newEquipment = RemapService.remapObjectToEquipment(object._equipment);
            if(location && newEquipment) {
                operation = new InstallationEquipment(
                    object._id,
                    object._idUser,
                    object._date,
                    newEquipment,
                    location,
                    object._isSynchro,
                    object._commentary
                );
            }
        }
        return operation;
    }

    isCorrect(): boolean {
        return (
            super.isCorrect() &&
            this.equipment !== undefined &&
            this.equipment.isCorrect()
        );
    }
}
